<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>Academics Calendar</h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-lg std-scholarship">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="inner-title" >
          <h4>Academics Calendar</h4>
         
        </div>
      </div>
      <div class="col-md-12 col-sm-12">
        <!-- <iframe src="https://drive.google.com/file/d/11889RTLiiOkpv3AG3w37rpAesYBfeY_B/preview" width="100%" height="650px"></iframe> -->
        <!-- <iframe
          src="https://docs.google.com/spreadsheets/d/e/2PACX-1vSOs0DkVLAPBbG2wnYP7-Suo-YZFqVMRU90Qr2hkpKxkQ0wcygyC6kvTD7yrZxg4g/pubhtml?widget=true&amp;headers=false"
          width="100%" height="650px"></iframe> -->
        <iframe src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/pdf/Academic+Calender+2022-23.pdf"
          width="100%" height="650px"></iframe>
      </div>
    </div>
  </div>
</section>